// extracted by mini-css-extract-plugin
export default {"item":"SubsectionItem_item__uc9UH","prefix":"SubsectionItem_prefix__dma15","suffix":"SubsectionItem_suffix__b63ml"};